/**
 * Header `Idempotency-Key` das escritas críticas do portal (hub#704).
 *
 * O backend deduplica pela chave: repetir a mesma requisição com a mesma chave devolve a resposta
 * da primeira em vez de executar de novo. Isso só serve para alguma coisa se o front **reenviar a
 * mesma chave** no retry — uma chave nova a cada clique é o mesmo que não mandar chave nenhuma.
 *
 * Por isso a chave é gerada por **operação lógica** (o clique do usuário) e não por requisição.
 */
export function idempotencyKey(): string {
  return crypto.randomUUID();
}

/** Config axios com o header. Passe a mesma chave ao repetir a operação. */
export function withIdempotencyKey(key: string = idempotencyKey()) {
  return { headers: { "Idempotency-Key": key } };
}
